export default __webpack_public_path__ + "static/media/background_main.ebea8205.webp";